import * as React from 'react';
import {Link} from 'react-router-dom';


interface IProps {
  school: string;
  course: any
}

const CourseItem = (props: IProps) => {
  const {course} = props;

  return(
    <div className='course-item'>
      <h3 style={{marginBottom: 0}}>
        <Link to={`courses/${course.slug}`} >{course.name}</Link>
      </h3>
      <span className='secondary-text'>{course.code}, {course.academicLevel}</span>
      <br/>
      <p>
        {course.description}
      </p>
    </div>
  )
};

export default CourseItem;